import auth from './auth'
import errors from './errors'
import metadata from './metadata'

export default {
  install (Vue, options) {
    // Vue.http.interceptors.push(req => {
    //   req.headers.set('Content-Type', 'application/json')
    // })
    Vue.prototype.$services = this
  },
  ...auth,
  ...metadata,
  ...errors
}



// WEBPACK FOOTER //
// ./src/services/index.js